import React, { type FC } from "react";
import { type ArticlePreviewType } from "~/types";
import PreviewGridLoop from "./ArticlePreview/PreviewGridLoop";
import Masonry from "react-masonry-css";
type GridLoopProps = {
  gridloop: ArticlePreviewType[];
  categoria: string;
  imageShow: boolean;
};
const breakpointColumnsObj = {
  default: 3,
  1280: 2,
  768: 1,
};
const GridLoop: FC<GridLoopProps> = ({
  gridloop,
  categoria = "category",
  imageShow = true,
}) => {
  const items = gridloop.map((el, index) => {
    return {
      id: index,
      articolo: el,
    };
  });

  return (
    <>
      {items && items.length > 0 && (
        <div className="mx-auto max-w-box">
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="flex gap-20"
            columnClassName="flex flex-col gap-20"
          >
            {items.map((item, index) => (
              <PreviewGridLoop
                key={index}
                data={item}
                categoria={categoria}
                imageShow={imageShow}
              />
            ))}
          </Masonry>
        </div>
      )}
    </>
  );
};

export default GridLoop;
